const docMissingEmployeeStatus = {
  text: 'EMPLOYEE MANUALLY BLOCKED'
};

export default docMissingEmployeeStatus;
